import { PolicyTermType } from '../../types/index';
import { addPolicyTerm } from "actions/Utilities/Policy";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useAddTerm = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, data } = useMutation((termNewData: PolicyTermType) => addPolicyTerm(termNewData));

  if (data) {
    if (data === "Duplicate") {
      toast.fire("Failed", "Failed to Add Term", "error");
    } else {
      queryClient.invalidateQueries(["GetTerms"]);
      toast.fire("Success", "Term Added Successfully", "success");
    }
  }

  return mutateAsync;
};
export default useAddTerm;
